import React, { useState, useEffect } from 'react';
import { getMainAxios } from '../utils/util';

interface StockSearchResult {
  prodId: string;
  prodNm: string;
  market: string;
}

interface StockSearchInputProps {
  value: string;                          // 선택된 종목코드
  onChange: (prodId: string, prodNm: string) => void;  // 종목 선택 시
  onClear?: () => void;                   // 클리어 시
  placeholder?: string;
  width?: number | string;
  disabled?: boolean;
}

const StockSearchInput: React.FC<StockSearchInputProps> = ({
  value, onChange, onClear, placeholder = '종목검색', width = 180, disabled = false
}) => {
  const axiosInstance = getMainAxios();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState<StockSearchResult[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedNm, setSelectedNm] = useState('');

  // 디바운스 검색
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (searchTerm && searchTerm.trim().length >= 2) {
        try {
          const res = await axiosInstance.get('/api/v1/stocks/search', {
            params: { term: searchTerm.trim(), limit: 15 }
          });
          if (res.data?.success && res.data?.data) {
            setResults(res.data.data);
            setShowDropdown(true);
          }
        } catch {
          setResults([]);
        }
      } else {
        setResults([]);
        setShowDropdown(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSelect = (stock: StockSearchResult) => {
    onChange(stock.prodId, stock.prodNm);
    setSelectedNm(stock.prodNm);
    setSearchTerm('');
    setResults([]);
    setShowDropdown(false);
  };

  const handleClear = () => {
    onChange('', '');
    setSelectedNm('');
    setSearchTerm('');
    setResults([]);
    setShowDropdown(false);
    onClear?.();
  };

  const displayValue = searchTerm || (value ? `${value} ${selectedNm}` : '');

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <input
        type="text"
        value={displayValue}
        onChange={e => {
          setSearchTerm(e.target.value);
          if (!e.target.value) handleClear();
        }}
        onFocus={() => { if (results.length > 0) setShowDropdown(true); }}
        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        disabled={disabled}
        placeholder={placeholder}
        style={{
          padding: '4px 8px',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
          fontSize: '12px',
          width: typeof width === 'number' ? `${width}px` : width,
          boxSizing: 'border-box',
        }}
      />
      {value && !searchTerm && (
        <button onClick={handleClear}
          style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '14px', padding: '0 2px' }}>
          x
        </button>
      )}
      {showDropdown && results.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '2px',
          backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: '4px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)', maxHeight: '200px', overflowY: 'auto', zIndex: 3000,
          minWidth: '220px',
        }}>
          {results.map((r, i) => (
            <div key={i}
              onMouseDown={e => { e.preventDefault(); handleSelect(r); }}
              style={{
                padding: '6px 10px', cursor: 'pointer',
                borderBottom: i < results.length - 1 ? '1px solid #e5e7eb' : 'none',
              }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#eff6ff')}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'white')}
            >
              <div style={{ fontSize: '12px', fontWeight: 600, color: '#1e40af' }}>{r.prodNm}</div>
              <div style={{ fontSize: '10px', color: '#6b7280' }}>{r.prodId} ({r.market})</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StockSearchInput;
